
//{tag: number, options: number}[]

import { useCallback, useState } from "react";
import { ASParamEditorProps } from "../ASParamEditor";
import { MDBCheckbox, MDBIcon, MDBInput } from "mdb-react-ui-kit";

export const ASUserTagsParam = ({param, currentValue, onCurrentValueChange, disabled}: ASParamEditorProps<{tag: number, options: number}[]>) => {
    const [selectedTagIdx, setSelectedTagIdx] = useState(-1);

    const onOptionSelect = useCallback((optionIdx: number, set: boolean) => {
        onCurrentValueChange(
            (currentValue ?? []).map((val, idx) => idx !== selectedTagIdx ? val : ({
                ...val,
                options: setOptionBit(val.options, optionIdx, set)
            }))
        )
    }, [currentValue, onCurrentValueChange, selectedTagIdx]);

    const onTagChange = useCallback((text: string) => {
        if (!/^[0-9a-fA-F]+$/.test(text)) return;

        const excess = Math.max(0, text.length - 8);

        onCurrentValueChange(
            (currentValue ?? []).map((val, idx) => idx !== selectedTagIdx ? val : ({
                ...val,
                tag: Math.max(0, Math.min(parseInt(text.slice(excess), 16), 0xFFFFFFFF))
            }))
        );
    }, [currentValue, onCurrentValueChange, selectedTagIdx]);


    return (
        <div className="d-flex flex-row">
            <div className="list-group list-group-flush h-100 p-0 overflow-auto" style={{flex: 3, minWidth: 150}}>
                {(currentValue ?? []).map((to, idx) =>
                    <div key={param.addr + '-tag-'+idx} role="button"
                        className={`d-flex align-items-center list-group-item${selectedTagIdx == idx?' active':''} user-select-none ps-2 py-2 pe-3`}
                        style={{flexWrap: "nowrap", fontSize: 14}}
                        onClick={() => setSelectedTagIdx(idx)}
                    >
                        <MDBIcon icon="tag" fixed/>
                        <span
                            className="ms-1"
                            style={{whiteSpace: 'nowrap', textOverflow: "clip", overflow: 'hidden', lineHeight: 1.1}}
                        >
                            {to.tag.toString(16).toLocaleUpperCase().padStart(8, '0')}
                        </span>
                    </div>
                )}
            </div>
            
            {(selectedTagIdx >= 0 && currentValue) &&
                <div className="d-flex flex-column p-2">
                    <MDBInput
                        label="Card code"
                        type="text"
                        value={currentValue[selectedTagIdx]?.tag.toString(16).toLocaleUpperCase().padStart(8, "0")}
                        onChange={ev => onTagChange(ev.currentTarget.value)}
                    />
                <div className="d-flex flex-column justify-content-start text-start mt-1">
                    {Array.from(new Array(8)).map((_, idx) => (
                        <MDBCheckbox
                            key={param.addr+'-tag-'+idx}
                            className=""
                            type="checkbox"
                            checked={currentValue!==null && Boolean(((currentValue[selectedTagIdx]?.options & (1 << idx))))}
                            disabled={disabled}
                            onChange={ev => {
                                onOptionSelect(idx, ev.currentTarget.checked);
                            }}
                            label={(param.items ?? [])[idx] ?? "???"}
                            labelStyle={{lineHeight: 1.4}}
                        />
                    ))}
                </div>
                
                </div>
            }
        </div>
    )
}

const setOptionBit = (val: number, idx: number, set: boolean) => {
    if (set) {
        return val | (1 << idx);
    } else {
        return val & ~(1 << idx);
    }
}